import * as React from 'react';
import { IPositionBooleanKey, TFlagKey } from 'types';
import { ValidateAuthentication } from './ValidateAuthentication';
import { ValidateFeatureFlags } from './ValidateFeatureFlags';
import { ValidatePermission } from './ValidatePermission';

export interface IAccessControlProps {
  authenticate: boolean;
  featureFlags?: TFlagKey | TFlagKey[];
  permissions?: IPositionBooleanKey | IPositionBooleanKey[];
}

export const AccessControl: React.FC<IAccessControlProps> = ({ children, authenticate, featureFlags, permissions }) => {
  return (
    <ValidateAuthentication authenticate={authenticate}>
      <ValidateFeatureFlags featureFlags={featureFlags}>
        <ValidatePermission permissions={permissions}>{children}</ValidatePermission>
      </ValidateFeatureFlags>
    </ValidateAuthentication>
  );
};
